import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

/**
 * Uygulama genelinde beklenmeyen render hatalarını yakalar.
 * Hata oluşursa tüm ekranı beyaza çevirmek yerine kullanıcı dostu
 * bir kurtarma ekranı gösterir.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-6">
          <div className="max-w-md w-full text-center space-y-6">
            <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-2xl flex items-center justify-center mx-auto">
              <AlertTriangle size={32} className="text-red-500" />
            </div>
            <div className="space-y-2">
              <h1 className="text-xl font-black text-slate-800 dark:text-white">
                Beklenmeyen Bir Hata Oluştu
              </h1>
              <p className="text-slate-500 dark:text-slate-400 text-sm">
                Uygulama beklenmedik bir hatayla karşılaştı. Sayfayı yenilemek sorunu çözebilir.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={this.handleRetry}
                className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold px-6 py-3 rounded-2xl transition-colors"
              >
                <RefreshCw size={16} />
                Tekrar Dene
              </button>
              <button
                onClick={() => window.location.reload()}
                className="flex items-center justify-center gap-2 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-bold px-6 py-3 rounded-2xl transition-colors"
              >
                Sayfayı Yenile
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
